import { createContext, useContext } from 'react';

/**
 * Context providing the current active session ID to child components
 * (e.g., RecordingPage needs sessionId for upload requests).
 */
export interface SessionContextValue {
  sessionId: string | null;
  location: string | null;
}

export const SessionContext = createContext<SessionContextValue>({ sessionId: null, location: null });

/**
 * Hook to access the current session ID from within components
 * rendered inside SessionTimer.
 */
export function useSessionId(): string | null {
  const ctx = useContext(SessionContext);
  return ctx.sessionId;
}

export function useSessionLocation(): string | null {
  const ctx = useContext(SessionContext);
  return ctx.location;
}
